import React from 'react';
import ArticleListPage from './ArticleListPage';
import { threatResearchPosts } from '../config/threatResearchPosts';

const ThreatResearchPage = () => (
  <ArticleListPage
    badge="Threat Research"
    title="In-Depth Research on"
    accentWord="Emerging Threats."
    desc="Technique-level breakdowns from our security team — how real attack patterns work, and how to actually detect them, not just a headline summary."
    sectionTag="Latest Research"
    sectionTitle="From the Proven InfoSec Threat Research Team"
    sectionDesc="Deep dives written for the people who have to defend against these techniques, not just read about them."
    posts={threatResearchPosts}
    basePath="/threat-research"
  />
);

export default ThreatResearchPage;
